import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { FeedbackCriteriaStateModel } from 'models/printing-photo/customer-feedback.model';
import { getFeedbackCriteriaApiAction } from 'store/api/feedback.slice-api';

const initialState: FeedbackCriteriaStateModel = {
  listFeedbackCriteria: {
    data: [],
    totalRecord: 0,
  },
  loadingInList: false,
};

export const feedbacCriterialSlice = createSlice({
  name: 'feedbackCriteria',
  initialState,
  reducers: {
    setFeedbackCriteriaStateAction: (
      state,
      action: PayloadAction<Partial<FeedbackCriteriaStateModel>>,
    ) => ({ ...state, ...action?.payload }),
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(getFeedbackCriteriaApiAction.matchPending, (state) => ({
        ...state,
        loadingInList: true,
      }))
      .addMatcher(getFeedbackCriteriaApiAction.matchRejected, (state) => ({
        ...state,
        loadingInList: false,
      }))
      .addMatcher(
        getFeedbackCriteriaApiAction.matchFulfilled,
        (state, { payload }) => ({
          ...state,
          listFeedbackCriteria: {
            data: payload?.data ?? [],
            totalRecord: payload?.totalRecord ?? 0,
          },
        }),
      );
  },
});

export const { setFeedbackCriteriaStateAction } = feedbacCriterialSlice.actions;

export default feedbacCriterialSlice.reducer;
